import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    request: {
        activeRowIndex: -1,
        visible: false,
        TransactionID: null,
        method: null
    },

    response: {
        transactionDetails: {},
        loading: true,
    },
    error: null,
}

const bobTransactionDetailsSlice = createSlice({
    name: "bobtransactionDetails",
    initialState,
    reducers: {
        setRequestData: (state, action) => {
            const {field, value} = action.payload;
            state.request[field] = value;
        },
        setResponseAbroadData: (state, action) => {
            const {field, value} = action.payload;
            state.response[field] = value;
        },
        resetRequest: (state) => {
            state.request = initialState.request;
        },
        resetResponse: (state) => {
            state.response = initialState.response;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    }
})

export const {
    setRequestData, setResponseAbroadData, resetRequest, resetResponse, setError
} = bobTransactionDetailsSlice.actions;

export default bobTransactionDetailsSlice.reducer;